var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfessional03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 54,
    viewBox: "0 0 55 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0122 41.625H34.5122M16.5122 33.75H39.0122M12.0122 4.5H43.5122C45.9975 4.5 48.0122 6.73858 48.0122 9.5V44.5C48.0122 47.2614 45.9975 49.5 43.5122 49.5H12.0122C9.52693 49.5 7.51221 47.2614 7.51221 44.5V9.5C7.51221 6.73858 9.52693 4.5 12.0122 4.5ZM27.7568 13.9769C26.1823 12.2238 23.5568 11.7522 21.584 13.3575C19.6113 14.9628 19.3336 17.6467 20.8828 19.5453C22.432 21.4439 27.7568 25.875 27.7568 25.875C27.7568 25.875 33.0817 21.4439 34.6309 19.5453C36.1801 17.6467 35.9362 14.9459 33.9296 13.3575C31.923 11.7691 29.3313 12.2238 27.7568 13.9769Z",
    stroke: "#278DEC",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfessional03);
export default __webpack_public_path__ + "static/media/professional03.fde5057cbdf57db6cfc33a1a4584c6e4.svg";
export { ForwardRef as ReactComponent };